import { GroupLifePlanType } from 'logic/subscription/plan/types'
import { EventArgs } from 'utils/analytics/types'

export const coverageSpec: Record<GroupLifePlanType, EventArgs['gl_plan_selected']['new_plan']> = {
  FREE_PLAN_GROUP_LIFE: 'none',
  GROUP_LIFE_10K: '10000',
  GROUP_LIFE_25K: '25000',
  GROUP_LIFE_50K: '50000',
}
